import {useRef, useState} from "react";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {Button, Divider} from "antd";
import Logo from "../../images/logo.png"
interface Props {
    type: string,
    data: any,
}
interface ListItemProps {
    label: string,
    value: string | undefined | null | number,
    className?: string
}

const ListItem = ({label, value, className}: ListItemProps) => {
    return <div className={`grid ${className} rounded-lg overflow-hidden grid-cols-2`}>
        <p className="bg-gray-200 mt-0 mb-0 border-r p-2 text-sm">{label}</p>
        <p className="bg-gray-100 mt-0 mb-0 p-2 text-sm">{value ? value.toString() : '-'}</p>
    </div>
}

interface ContentProps {
    data: any
}

const ReplyToInquiryModalContent = (props: ContentProps) => {
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={"شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const ChangeAccountModalContent = (props: ContentProps) => {
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={"شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem label={"نوع کاربری فعلی"} value={data?.currenAccountName}/>
        <ListItem label={"نوع کاربری جدید"} value={data?.newAccountTypeName}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}

const ChangeSpecificationsModalContent = (props: ContentProps) => {
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={"شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-1" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-1" label={"کد اقتصادی / شناسه ملی"} value={data?.BusinessNumber}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const ChangeUnitContentModal=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={"شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem label={"تعداد واحد فعلی"} value={data?.CurrentUnit}/>
        <ListItem label={"تعداد واحد جدید"} value={data?.NewUnit}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const ChangeCapacityContractualBranchingContentModal=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={"شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem label={"ظرفیت فعلی"} value={data?.CurrentCapacity}/>
        <ListItem label={"ظرفیت جدید"} value={data?.NewCapacity}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const ChangeBranchDiameterContentModal=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={"شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem label={"قطر انشعاب قبلی"} value={data?.CurrentBranchDiameter}/>
        <ListItem label={"قطر انشعاب جدید"} value={data?.NewBranchDiameter}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}

const MeterSeparationContentModal=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const MoveMeasuringDevicesContentModal=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const MeterTestContentModal=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const MeterChangeModalContent=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const InstallAdditionalSiphonModalContent=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const TemporaryDisconnectAndConnectBranchModalContent=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const MidTermBillModalContent=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-1" label={"ایمیل"} value={data?.Email}/>
        <ListItem label={"تاریخ قرائت فعلی"} value={data?.ReadingDate}/>
        <ListItem label={"شماره کنتور قبلی"} value={data?.PreviousMeterNumber}/>
        <ListItem label={"شماره کنتور فعلی"} value={data?.CurrentMeterNumber}/>

        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const CollectOrMergeBranchModalContent=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const BillingReviewModalContent=(props: ContentProps)=>{
    const {data} = props;
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-1" label={"نوع بررسی"} value={data?.BillingReviewTypeName}/>
        <ListItem className="col-span-1" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}

const DeclareMeterConsumptionModalContent=(props: ContentProps)=>{
    const {data} = props;
    console.log(data)
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem label={"رقم کارکرد فعلی کنتور"} value={data?.PreviousMeterNumber}/>
        <ListItem label={"تاریخ قرائت فعلی"} value={data?.PreviousReadingDate}/>
    </div>
}
const WastWaterBranchAssignmentModalContent=(props: ContentProps)=>{
    const {data} = props;
    console.log(data)
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const WaterBranchAssignmentModalContent=(props: ContentProps)=>{
    const {data} = props;
    console.log(data)
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={" شهر"} value={data?.cityName}/>
        <ListItem label={" روستا"} value={data?.villageName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-2" label={"شماره پلاک ثبتی"} value={data?.Plaque}/>
        <ListItem className="col-span-2" label={"نوع درخواست تسهیلات قانونی"} value={data?.requestTypeName}/>
        <ListItem className="col-span-2" label={"نوع سند ملک"} value={data?.constructionDocName}/>
        <ListItem className="col-span-2" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس "} value={data?.Address}/>
    </div>
}
const SaleTankerWaterModalContent=(props: ContentProps)=>{
    const {data} = props;
    console.log(data)
    return <div className="grid grid-cols-2  gap-3 ">
        <ListItem label={"نام"} value={data?.FirstName}/>
        <ListItem label={"نام خانوادگی"} value={data?.LastName}/>
        <ListItem label={"شناسه قبض"} value={data?.FileNumber}/>
        <ListItem label={" شهر"} value={data?.CityName}/>
        <ListItem label={"کد ملی"} value={data?.NationalCode}/>
        <ListItem label={"کد پستی"} value={data?.PostalCode}/>
        <ListItem label={"شماره تلفن"} value={data?.TelNumber}/>
        <ListItem label={"شماره موبایل"} value={data?.MobileNumber}/>
        <ListItem className="col-span-1" label={"حجم آب ( متر مکعب )"} value={data?.WaterVolume}/>
        <ListItem className="col-span-1" label={"ایمیل"} value={data?.Email}/>
        <ListItem className="col-span-2" label={"آدرس محل مورد تقاضا"} value={data?.Address}/>
    </div>
}
const ConfirmInfoModal = (props: Props) => {
    const {type, data} = props;
    const divRef = useRef<HTMLDivElement>(null);
    const [loading,setLoading]=useState(false)


    const generatePdf = async () => {

        const input = divRef.current;
        if (input) {
            setLoading(true)
            try {
                const canvas = await html2canvas(input);
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                const imgProps = pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                pdf.save('download.pdf');
                setLoading(false)
            } catch (err) {
                console.error('Error generating PDF:', err);
                setLoading(false)
            }
        }
    };


    return <>
        <div ref={divRef} className=" py-10  px-5 mx-3   rounded-lg border  mb-2 ">
            <div className="flex w-full flex-col items-center justify-center gap-2  mb-3">
                <img alt="logo" className="w-[50px] h-auto  h-auto" src={Logo}/>
                <h1 className="text-2xl font-bold">آب و فاضلاب استان مازندران</h1>
            </div>
            <p className="text-center mb-4   ">اطلاعات وارد شده به صورت زیر می‌باشد.</p>
            {type === "ReplyToInquiry" && <ReplyToInquiryModalContent data={data}/>}
            {type === "ChangeAccountType" && <ChangeAccountModalContent data={data}/>}
            {type === "ChangeSpecifications" && <ChangeSpecificationsModalContent data={data}/>}
            {type === "ChangeUnit" && <ChangeUnitContentModal data={data}/>}
            {type === "ChangeCapacityContractualBranching" && <ChangeCapacityContractualBranchingContentModal data={data}/>}
            {type === "ChangeBranchDiameter" && <ChangeBranchDiameterContentModal data={data}/>}
            {type === "MeterSeparation" && <MeterSeparationContentModal data={data}/>}
            {type === "MoveMeasuringDevice" && <MoveMeasuringDevicesContentModal data={data}/>}
            {type === "MeterTest" && <MeterTestContentModal data={data}/>}
            {type === "MeterChange" && <MeterChangeModalContent data={data}/>}
            {type === "InstallAdditionalSiphon" && <InstallAdditionalSiphonModalContent data={data}/>}
            {type === "TemporaryDisconnectAndConnectBranch" && <TemporaryDisconnectAndConnectBranchModalContent data={data}/>}
            {type === "MidTermBill" && <MidTermBillModalContent data={data}/>}
            {type === "CollectOrMergeBranch" && <CollectOrMergeBranchModalContent data={data}/>}
            {type === "BillingReview" && <BillingReviewModalContent data={data}/>}
            {type === "DeclareMeterConsumption" && <DeclareMeterConsumptionModalContent data={data}/>}
            {type === "WastWaterBranchAssignment" && <WastWaterBranchAssignmentModalContent data={data}/>}
            {type === "WaterBranchAssignment" && <WaterBranchAssignmentModalContent data={data}/>}
            {type === "SaleTankerWater" && <SaleTankerWaterModalContent data={data}/>}
        </div>
        <Divider/>
        <Button onClick={generatePdf} loading={loading} type="default">ذخیره PDF</Button>
        <Divider/>

    </>
}


export default ConfirmInfoModal;